/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxListBoxComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxlistbox';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcListBoxComponent),
    multi: true
};

/**
 * List Box
 */

export class NgcListBoxComponent extends ControlComponent {
     autoHeight: any;
     allowDrag: any;
     allowDrop: any;
     checkboxes: any;
     displayMember: any;
     dropAction: any;
     dragStart: any;
     dragEnd: any;
     enableHover: any;
     enableSelection: any;
     equalItemsWidth: any;
     filterable: any;
     filterHeight: any;
     filterDelay: any;
     filterPlaceHolder: any;
     hasThreeStates: any;
     itemHeight: any;
     incrementalSearch: any;
     incrementalSearchDelay: any;
     multiple: any;
     multipleextended: any;
     renderer: any;
     rtl: any;
     selectedIndex: any;
     selectedIndexes: any;
     source: any;
     scrollBarSize: any;
     searchMode: any;
     theme: any;
     valueMember: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

     jqxListBox: jqxListBoxComponent;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Select
     * 
     * @param Event
     */
    selectionChange($e) {
        if (this.multiple) {
            let selectedItems: any[] = this.findSelectedItems();
            this.value = selectedItems;
        } else {
            this.value = $e.args.item.value;
        }
    }

    /**
     * Find Selected Items
     */
    findSelectedItems() {
        let selections = this.jqxListBox.getSelectedItems();
        let selectionArr = [];
        //
        for (let index = 0; index < selections.length; index++) {
            selectionArr = selectionArr.concat(selections[index].label);
        }
        return selectionArr;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-listbox',
    template: `<jqxListBox *ngIf="visible" #jqxListBox (onChange)="selectionChange($event)"
                [autoHeight] = "autoHeight"
                [allowDrag] = "allowDrag"
                [allowDrop] = "allowDrop"
                [checkboxes] = "checkboxes"
                [disabled] = "disabled"
                [displayMember] = "displayMember"
                [dropAction] = "dropAction"
                [dragStart] = "dragStart"
                [dragEnd] = "dragEnd"
                [enableHover] = "enableHover"
                [enableSelection] = "enableSelection"
                [equalItemsWidth] = "equalItemsWidth"
                [filterable] = "filterable"
                [filterHeight] = "filterHeight"
                [filterDelay] = "filterDelay"
                [filterPlaceHolder] = "filterPlaceHolder"
                [hasThreeStates] = "hasThreeStates"
                [itemHeight] = "itemHeight"
                [incrementalSearch] = "incrementalSearch"
                [incrementalSearchDelay] = "incrementalSearchDelay"
                [multiple] = "multiple"
                [multipleextended] = "multipleextended"
                [renderer] = "renderer"
                [rtl] = "rtl"
                [selectedIndex] = "selectedIndex"
                [selectedIndexes] = "selectedIndexes"
                [source] = "source"
                [scrollBarSize] = "scrollBarSize"
                [searchMode] = "searchMode"
                [theme] = "theme"
                [valueMember] = "valueMember"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxListBox>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'autoHeight': [{ type: Input, args: ['autoHeight', ] },],
'allowDrag': [{ type: Input, args: ['allowDrag', ] },],
'allowDrop': [{ type: Input, args: ['allowDrop', ] },],
'checkboxes': [{ type: Input, args: ['checkboxes', ] },],
'displayMember': [{ type: Input, args: ['displayMember', ] },],
'dropAction': [{ type: Input, args: ['dropAction', ] },],
'dragStart': [{ type: Input, args: ['dragStart', ] },],
'dragEnd': [{ type: Input, args: ['dragEnd', ] },],
'enableHover': [{ type: Input, args: ['enableHover', ] },],
'enableSelection': [{ type: Input, args: ['enableSelection', ] },],
'equalItemsWidth': [{ type: Input, args: ['equalItemsWidth', ] },],
'filterable': [{ type: Input, args: ['filterable', ] },],
'filterHeight': [{ type: Input, args: ['filterHeight', ] },],
'filterDelay': [{ type: Input, args: ['filterDelay', ] },],
'filterPlaceHolder': [{ type: Input, args: ['filterPlaceHolder', ] },],
'hasThreeStates': [{ type: Input, args: ['hasThreeStates', ] },],
'itemHeight': [{ type: Input, args: ['itemHeight', ] },],
'incrementalSearch': [{ type: Input, args: ['incrementalSearch', ] },],
'incrementalSearchDelay': [{ type: Input, args: ['incrementalSearchDelay', ] },],
'multiple': [{ type: Input, args: ['multiple', ] },],
'multipleextended': [{ type: Input, args: ['multipleextended', ] },],
'renderer': [{ type: Input, args: ['renderer', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'selectedIndex': [{ type: Input, args: ['selectedIndex', ] },],
'selectedIndexes': [{ type: Input, args: ['selectedIndexes', ] },],
'source': [{ type: Input, args: ['source', ] },],
'scrollBarSize': [{ type: Input, args: ['scrollBarSize', ] },],
'searchMode': [{ type: Input, args: ['searchMode', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'valueMember': [{ type: Input, args: ['valueMember', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
'jqxListBox': [{ type: ViewChild, args: ['jqxListBox', ] },],
};
}

/**
 * List Box Module
 */

export class NgcListBoxModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcListBoxComponent],
    declarations: [NgcListBoxComponent, jqxListBoxComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
